export default "__VITE_ASSET__BQe3qyhK__"